export default {
  "unableToLoadOutlets": "No se pudieron cargar los puntos de venta",
  "unableToLoadDiningAreas": "No se pudieron cargar las zonas de comedor",
  "unableToLoadTables": "No se pudieron cargar las mesas",
  "unableToLoadFloorPlan": "No se pudo cargar el plano",
  "couldNotUploadDiningImage": "No se pudo subir la imagen del comedor",
  "diningImageSaved": "Imagen del comedor guardada",
  "thePreviewIsTemporarilyUnavailableItWillAppearAutomaticallyWhenImageDeliveryRecovers": "La vista previa no está disponible temporalmente. Aparecerá automáticamente cuando se restablezca el servicio de imágenes.",
  "unableToSaveArea": "No se pudo guardar la zona",
  "chooseASupportedImage": "Elige una imagen compatible",
  "diningImageRemoved": "Imagen del comedor eliminada",
  "theChangeWasSavedButThePreviewServiceIsTemporarilyUnavailable": "El cambio se ha guardado, pero el servicio de vista previa no está disponible temporalmente.",
  "unableToRemoveImage": "No se pudo eliminar la imagen",
  "unableToDeactivateArea": "No se pudo desactivar la zona",
  "cancellationPolicySaved": "Política de cancelación guardada",
  "unableToSaveTable": "No se pudo guardar la mesa",
  "qRDownloadReady": "Descarga del QR lista",
  "yourPrivanaDiningQRFileHasBeenGenerated": "Se ha generado el archivo QR de Comedor de Privana.",
  "unableToGenerateQR": "No se pudo generar el QR",
  "unableToLoadQRPreview": "No se pudo cargar la vista previa del QR",
  "thePublicQRURLHasBeenCopied": "Se ha copiado la URL pública del QR.",
  "unableToDeactivateTable": "No se pudo desactivar la mesa",
  "unableToBulkAddTables": "No se pudieron añadir las mesas en bloque",
  "floorPlanSaved": "Plano guardado",
  "yourLayoutChairsWallsAndDoorsWereSaved": "Se han guardado la distribución, las sillas, las paredes y las puertas.",
  "unableToSaveFloorPlan": "No se pudo guardar el plano",
  "openHostConsoleInANewTab": "Abrir la consola de recepción en una pestaña nueva",
  "openHostConsole": "Abrir consola de recepción",
  "addArea": "Añadir zona",
  "diningAreas": "Zonas de comedor",
  "manageSharedRoomSectionsIndependentlyFromPOSOutletAssignments": "Gestiona las zonas compartidas del comedor independientemente de las asignaciones a puntos de venta del TPV.",
  "loadingDiningAreas": "Cargando zonas de comedor…",
  "noDiningAreasYetCreateYourFirstAreaToBegin": "Todavía no hay zonas de comedor. Crea la primera para empezar.",
  "sharedDiningServiceSpace": "Espacio compartido de servicio de comedor",
  "active": "Activo",
  "inactive": "Inactivo",
  "unableToUpdateArea": "No se pudo actualizar la zona",
  "generateAreaQR": "Generar QR de zona",
  "cancellationPolicy": "Política de cancelación",
  "edit": "Editar",
  "deactivate": "Desactivar",
  "tables": "Mesas",
  "buildATableListForTheSelectedDiningArea": "Crea una lista de mesas para la zona de comedor seleccionada.",
  "diningArea": "Zona de comedor",
  "selectArea": "Seleccionar zona",
  "generateTableQRs": "Generar QR de mesas",
  "bulkAdd": "Añadir en bloque",
  "addTable": "Añadir mesa",
  "loadingTables": "Cargando mesas…",
  "selectADiningAreaToViewTables": "Selecciona una zona de comedor para ver las mesas.",
  "thisArea": "esta zona",
  "table": "Mesa",
  "capacity": "Capacidad:",
  "unableToUpdateTable": "No se pudo actualizar la mesa",
  "editDiningArea": "Editar zona de comedor",
  "addDiningArea": "Añadir zona de comedor",
  "areaName": "Nombre de la zona",
  "restaurant": "Restaurante",
  "activeArea": "Zona activa",
  "enableOrDisableThisDiningArea": "Activa o desactiva esta zona de comedor.",
  "diningImage": "Imagen del comedor",
  "forBestResultsUseALandscapeImageAtLeast1600900pxJPEGPNGOrWebPUpTo5MB": "Para obtener mejores resultados, usa una imagen horizontal de al menos 1600 × 900 px. JPEG, PNG o WebP, hasta 5 MB.",
  "diningAreaPreview": "Vista previa de la zona de comedor",
  "previewUnavailableYourImageIsStillSaved": "Vista previa no disponible; la imagen sigue guardada",
  "addAWelcomingDiningHero": "Añade una imagen de cabecera acogedora del comedor",
  "replaceImage": "Sustituir imagen",
  "uploadImage": "Subir imagen",
  "removeImage": "Eliminar imagen",
  "altTextOptional": "Texto alternativo (opcional)",
  "candlelitTerraceOverlookingTheGarden": "Terraza a la luz de las velas con vistas al jardín",
  "horizontalFocus": "Enfoque horizontal",
  "verticalFocus": "Enfoque vertical",
  "securelySavingDiningArea": "Guardando la zona de comedor de forma segura…",
  "cancel": "Cancelar",
  "saving": "Guardando…",
  "saveArea": "Guardar zona",
  "thisDiningArea": "esta zona de comedor",
  "minimumNoticeHoursBeforeReservationStart": "Horas mínimas de antelación al inicio de la reserva",
  "removeDiningImage": "¿Eliminar la imagen del comedor?",
  "membersWillSeeYourClubHeroOrPrivanaSDiningFallbackInsteadThisCannotBeUndone": "Los socios verán la imagen de cabecera del club o la imagen predeterminada de comedor de Privana. Esta acción no se puede deshacer.",
  "keepImage": "Conservar imagen",
  "removing": "Eliminando…",
  "editTable": "Editar mesa",
  "addTableLabel": "Añadir mesa",
  "label": "Etiqueta",
  "table12": "Mesa 12",
  "capacityLabel": "Capacidad",
  "activeTable": "Mesa activa",
  "deactivateToHideThisTableOnPOS": "Desactívala para ocultar esta mesa en el TPV.",
  "saveTable": "Guardar mesa",
  "bulkAddTables": "Añadir mesas en bloque",
  "startNumber": "Número inicial",
  "endNumber": "Número final",
  "prefixOptional": "Prefijo (opcional)",
  "capacityOptional": "Capacidad (opcional)",
  "createTables": "Crear mesas",
  "fileType": "Tipo de archivo",
  "previewQRCode": "Vista previa del código QR",
  "previewTableQRCodes": "Vista previa de los códigos QR de mesas",
  "loadingQRPreview": "Cargando vista previa del QR…",
  "areaQRPreview": "Vista previa del QR de zona",
  "openLink": "Abrir enlace",
  "copyURL": "Copiar URL",
  "open": "Abrir",
  "copy": "Copiar",
  "generating": "Generando…",
  "generateDownload": "Generar / Descargar",
  "checkIn": "Registrar llegada",
  "seat": "Sentar",
  "complete": "Completar",
  "confirm": "Confirmar",
  "staff": "Personal",
  "membersPortal": "Portal de socios",
  "membersApp": "App de socios",
  "guest": "Invitado",
  "walkIn": "Sin reserva",
  "accessDenied": "Acceso denegado.",
  "unableToLoadDiningReservations": "No se pudieron cargar las reservas de comedor.",
  "today": "Hoy",
  "tomorrow": "Mañana",
  "future": "Próximas",
  "functions": "Funciones",
  "createReservation": "Crear reserva",
  "addWalkIn": "Añadir sin reserva",
  "viewPastBookings": "Ver reservas anteriores",
  "manageTableBlocks": "Gestionar bloqueos de mesas",
  "retry": "Reintentar",
  "dismiss": "Cerrar",
  "notesOrAllergyInformation": "Notas o información sobre alergias",
  "noReservations": "No hay reservas",
  "reservation": "Reserva",
  "date": "Fecha",
  "time": "Hora",
  "partySize": "Número de comensales",
  "duration": "Duración",
  "memberNotes": "Notas del socio",
  "staffNotes": "Notas del personal",
  "reasonForCancelNoShow": "Motivo de cancelación o inasistencia",
  "saveChanges": "Guardar cambios",
  "reject": "Rechazar",
  "noShow": "No presentado",
  "reservationType": "Tipo de reserva",
  "existingMember": "Socio existente",
  "memberSearch": "Búsqueda de socios",
  "searchMember": "Buscar socio",
  "guestName": "Nombre del invitado",
  "email": "Correo electrónico",
  "phone": "Teléfono",
  "tableOptional": "Mesa (opcional)",
  "createReservationLabel": "Crear reserva",
  "pastBookings": "Reservas anteriores",
  "memberGuestOrReference": "Socio, invitado o referencia",
  "allStatuses": "Todos los estados",
  "allAreas": "Todas las zonas",
  "search": "Buscar",
  "previous": "Anterior",
  "of": "de",
  "next": "Siguiente",
  "reason": "Motivo",
  "saveBlock": "Guardar bloqueo",
  "addBlock": "Añadir bloqueo",
  "delete": "Eliminar",
  "deleteTableBlock": "¿Eliminar el bloqueo de mesa?",
  "thisWillReturnTheTableToAvailabilityForTheBlockedPeriod": "La mesa volverá a estar disponible durante el periodo bloqueado.",
  "keepBlock": "Conservar bloqueo",
  "deleteBlock": "Eliminar bloqueo",
  "autoAssign": "Asignar automáticamente",
  "sunday": "Domingo",
  "monday": "Lunes",
  "tuesday": "Martes",
  "wednesday": "Miércoles",
  "thursday": "Jueves",
  "friday": "Viernes",
  "saturday": "Sábado",
  "addAtLeastOneServiceWindow": "Añade al menos una franja de servicio.",
  "minimumPartySizeCannotExceedMaximumPartySize": "El número mínimo de comensales no puede superar el máximo.",
  "reservations": "Reservas",
  "configureMemberAndGuestBookingAvailability": "Configura la disponibilidad de reservas para socios e invitados.",
  "reservationDays": "Días de reserva",
  "serviceWindows": "Franjas de servicio",
  "addWindow": "Añadir franja",
  "windowStart": "Inicio de la franja",
  "windowEnd": "Fin de la franja",
  "removeServiceWindow": "Eliminar franja de servicio",
  "bookingIntervalMinutes": "Intervalo de reservas (minutos)",
  "defaultDurationMinutes": "Duración predeterminada (minutos)",
  "minimumPartySize": "Número mínimo de comensales",
  "maximumPartySize": "Número máximo de comensales",
  "maximumDaysAhead": "Días máximos de antelación",
  "minimumNoticeMinutes": "Antelación mínima (minutos)",
  "cancellationWindowMinutes": "Plazo de cancelación (minutos)",
  "requireStaffApproval": "Requerir aprobación del personal",
  "allowGuestReservations": "Permitir reservas de invitados",
  "allowWalkIns": "Permitir clientes sin reserva",
  "small": "Pequeño",
  "medium": "Mediano",
  "large": "Grande",
  "general": "General",
  "mainDining": "Comedor principal",
  "windowSeating": "Junto a la ventana",
  "privateDining": "Comedor privado",
  "bar": "Barra",
  "patio": "Patio",
  "terrace": "Terraza",
  "event": "Evento",
  "lounge": "Salón",
  "quietArea": "Zona tranquila",
  "familyArea": "Zona familiar",
  "highTop": "Mesa alta",
  "staffOnly": "Solo personal",
  "custom": "Personalizado",
  "round2": "Redonda de 2",
  "roundTables": "Mesas redondas",
  "round4": "Redonda de 4",
  "round6": "Redonda de 6",
  "round8": "Redonda de 8",
  "square2": "Cuadrada de 2",
  "squareTables": "Mesas cuadradas",
  "square4": "Cuadrada de 4",
  "rectangle4": "Rectangular de 4",
  "rectangleTables": "Mesas rectangulares",
  "rectangle6": "Rectangular de 6",
  "rectangle8": "Rectangular de 8",
  "rectangle10": "Rectangular de 10",
  "ovalBanquet": "Ovalada / banquete",
  "specialSeating": "Asientos especiales",
  "booth": "Reservado",
  "barCounter": "Barra / mostrador",
  "serviceStation": "Estación de servicio",
  "operations": "Operaciones",
  "diningZone": "Zona de comedor",
  "object": "Objeto",
  "wallPath": "Trazado de pared",
  "door": "Puerta",
  "floorPlanImage": "Imagen del plano",
  "selectionHandle": "Control de selección",
  "dining": "Comedor",
  "floorPlanBuilder": "Editor de planos",
  "dragTablesDrawWallsToggleIndividualChairsAndSaveAClubScopedLayout": "Arrastra mesas, dibuja paredes, activa o desactiva sillas individuales y guarda una distribución para el club.",
  "selectDiningArea": "Seleccionar zona de comedor",
  "selectAnArea": "Selecciona una zona",
  "reload": "Volver a cargar",
  "save": "Guardar",
  "duplicateTableLinksWereRepairedReviewUnlinkedTablesBeforeSaving": "Se han reparado los enlaces duplicados de mesas. Revisa las mesas sin vincular antes de guardar.",
  "chooseADiningAreaToStart": "Elige una zona de comedor para empezar",
  "theBuilderWillKeepEachLayoutScopedToTheCurrentClubAndSelectedArea": "El editor mantendrá cada distribución vinculada al club actual y a la zona seleccionada.",
  "palette": "Elementos",
  "clickOrDragOntoTheCanvas": "Haz clic o arrastra al lienzo.",
  "select": "Seleccionar",
  "wall": "Pared",
  "zone": "Zona",
  "ops": "Operaciones",
  "clickMoreWallPointsDoubleClickToFinishOrClickTheFirstPointToClose": "Añade puntos a la pared. Haz doble clic para terminar o pulsa el primer punto para cerrar.",
  "clickTheWallStartPoint": "Pulsa el punto inicial de la pared.",
  "clickMoreZonePointsDoubleClickToFinishOrClickTheFirstPointToClose": "Añade puntos a la zona. Haz doble clic para terminar o pulsa el primer punto para cerrar.",
  "clickTheFirstZonePoint": "Pulsa el primer punto de la zona.",
  "dragToMoveItemsShiftClickToSelectMultiple": "Arrastra para mover elementos. Mayús + clic para seleccionar varios.",
  "canvasSize": "Tamaño del lienzo",
  "tracingMode": "Modo de calco",
  "showZones": "Mostrar zonas",
  "zoneLegend": "Leyenda de zonas",
  "legend": "Leyenda",
  "keyboardShortcuts": "Atajos de teclado",
  "wallTool": "Herramienta de pared",
  "zoneTool": "Herramienta de zona",
  "selectOrCancel": "Seleccionar o cancelar",
  "deleteSelected": "Eliminar selección",
  "duplicate": "Duplicar",
  "undo": "Deshacer",
  "redo": "Rehacer",
  "rotate15": "Girar 15°",
  "arrows": "Flechas",
  "nudgeShift5x": "Desplazar (Mayús = 5×)",
  "deleteObjects": "Eliminar objetos",
  "exitFullScreen": "Salir de pantalla completa",
  "fullScreen": "Pantalla completa",
  "loadingFloorPlan": "Cargando plano…",
  "uploadAFloorPlanImageAlignItLockItThenTraceWallsOverTheTop": "Sube una imagen del plano, alinéala, bloquéala y calca las paredes encima.",
  "hideTracingMode": "Ocultar modo de calco",
  "unlockImage": "Desbloquear imagen",
  "lockImage": "Bloquear imagen",
  "showBackgroundImage": "Mostrar imagen de fondo",
  "opacity": "Opacidad",
  "tracingImageOpacity": "Opacidad de la imagen de calco",
  "rotation": "Rotación",
  "tracingImageRotation": "Rotación de la imagen de calco",
  "width": "Anchura",
  "tracingImageWidth": "Anchura de la imagen de calco",
  "height": "Altura",
  "tracingImageHeight": "Altura de la imagen de calco",
  "rotateLeft": "Girar a la izquierda",
  "rotateRight": "Girar a la derecha",
  "fitImageToCanvas": "Ajustar imagen al lienzo",
  "clearImage": "Quitar imagen",
  "pNGJPGJPEGAndWebPFilesAreSavedLocallyInTheFloorPlanLayoutJSONForNow": "Por ahora, los archivos PNG, JPG, JPEG y WebP se guardan localmente en el JSON de la distribución del plano.",
  "startWithAPolishedEmptyPlan": "Empieza con un plano vacío",
  "addATableFromThePaletteDrawAWallOrDropInADoorEverythingSnapsToTheGrid": "Añade una mesa desde los elementos, dibuja una pared o coloca una puerta. Todo se ajusta a la cuadrícula.",
  "seats": "plazas",
  "pressEscToExitFullScreen": "Pulsa Esc para salir de pantalla completa",
  "rotateHandle": "Control de rotación",
  "service": "Servicio",
  "inspector": "Inspector",
  "multipleSelected": "Varios elementos seleccionados",
  "selectAnItemToEditDetails": "Selecciona un elemento para editar sus detalles.",
  "useTheLeftPaletteToAddWallsDoorsTablesBoothsBarsAndServiceStations": "Usa los elementos de la izquierda para añadir paredes, puertas, mesas, reservados, barras y estaciones de servicio.",
  "chairsAreChildrenOfTableTemplatesClickAChairOnTheCanvasToDisableOrEnableThatSeat": "Las sillas pertenecen a las plantillas de mesa. Pulsa una silla en el lienzo para activar o desactivar esa plaza.",
  "doorOpening": "Puerta / abertura",
  "tableObject": "Objeto de mesa",
  "nameLabel": "Nombre / etiqueta",
  "zoneType": "Tipo de zona",
  "zoneTypeLabel": "Tipo de zona",
  "color": "Color",
  "zoneColor": "Color de la zona",
  "zoneColorValue": "Valor del color de la zona",
  "zoneCapacity": "Capacidad de la zona",
  "activeTableSeats": "Plazas de mesas activas",
  "tablesInZone": "Mesas en la zona",
  "activeTables": "Mesas activas",
  "totalSeats": "Total de plazas",
  "includesInactiveTables": "Incluye mesas inactivas",
  "layerPosition": "Posición de la capa",
  "layer": "Capa",
  "showZone": "Mostrar zona",
  "hiddenZonesAreNotShownButCanStillAssignReport": "Las zonas ocultas no se muestran, pero siguen disponibles para asignaciones e informes.",
  "bringForward": "Adelantar",
  "sendBackward": "Retrasar",
  "bringToFront": "Traer al frente",
  "sendToBack": "Enviar al fondo",
  "cloneZone": "Clonar zona",
  "tableNumber": "Número de mesa",
  "linkedDiningTable": "Mesa de comedor vinculada",
  "createOrLinkTable": "Crear o vincular mesa",
  "createNewOnSave": "Crear nueva al guardar",
  "linkedDiningTableLabel": "Mesa de comedor vinculada",
  "sourceOfTruth": "Fuente de referencia:",
  "noArea": "Sin zona",
  "outlet": "Punto de venta",
  "noOutlet": "Sin punto de venta",
  "capacityComesFromTheLinkedDiningTableSourceOfTruth": "La capacidad procede del registro de la mesa de comedor vinculada.",
  "capacityIsControlledByEnabledChairObjects": "La capacidad depende de las sillas activadas.",
  "points": "Puntos",
  "edges": "Bordes",
  "segments": "Segmentos",
  "inactiveZonesDoNotAssignReport": "Las zonas inactivas no se incluyen en asignaciones ni informes.",
  "inactiveObjectsAreFadedOnThePlan": "Los objetos inactivos se muestran atenuados en el plano.",
  "deleteZone": "Eliminar zona",
  "deleteItem": "Eliminar elemento",
  "diningHostConsole": "Consola de recepción de comedor",
  "thePublishedFloorCouldNotBeDisplayed": "No se pudo mostrar el plano publicado.",
  "reservationsAndServiceDataAreStillAvailable": "Las reservas y los datos de servicio siguen disponibles.",
  "refreshingFloor": "Actualizando plano…",
  "retryFloor": "Volver a cargar plano",
  "publishedDiningFloorPlan": "Plano de comedor publicado",
  "interactiveDiningFloorDragToMoveUseTheMouseWheelOrPinchGestureToZoom": "Plano interactivo del comedor. Arrastra para moverlo. Usa la rueda del ratón o el gesto de pellizco para ampliar o reducir.",
  "zoomOut": "Reducir",
  "fitFloor": "Ajustar plano",
  "zoomIn": "Ampliar",
  "guestParty": "Grupo de invitados",
  "authenticatedStaff": "Personal autenticado",
  "floor": "Plano",
  "unableToPrepareDiningOperations": "No se pudieron preparar las operaciones de comedor.",
  "unableToRefreshDiningOperations": "No se pudieron actualizar las operaciones de comedor.",
  "thisReservationChangedOnAnotherDeviceTheLatestDetailsHaveBeenLoaded": "Esta reserva ha cambiado en otro dispositivo. Se han cargado los datos más recientes.",
  "actionFailed": "La acción ha fallado.",
  "waitlist": "Lista de espera",
  "arrived": "Llegadas",
  "seated": "Sentados",
  "available": "Disponibles",
  "late": "Con retraso",
  "noShows": "No presentados",
  "weCouldnTLogYouOutPleaseTryAgain": "No se pudo cerrar la sesión. Inténtalo de nuevo.",
  "noDiningAreasConfigured": "No hay zonas de comedor configuradas",
  "covers": "comensales",
  "signOut": "Cerrar sesión",
  "hostConsole": "Consola de recepción",
  "todaySOperationalSummary": "Resumen operativo de hoy",
  "preparingTodaySFloorAndReservations": "Preparando el plano y las reservas de hoy…",
  "liveFloor": "Plano en directo",
  "refreshing": "Actualizando",
  "noActiveDiningAreasAreConfigured": "No hay zonas de comedor activas configuradas",
  "noActiveDiningTablesAreConfigured": "No hay mesas de comedor activas configuradas",
  "noPublishedFloorPlanIsAvailableForThisArea": "No hay un plano publicado disponible para esta zona",
  "markThisReservationAsNoShow": "¿Marcar esta reserva como no presentada?",
  "completeThisDiningVisit": "¿Completar esta visita al comedor?",
  "comingNextThisPhaseKeepsFocusOnLiveFloorAndReservationOperations": "Próximamente. Esta fase se centra en el plano en directo y las operaciones de reservas.",
  "servicePulse": "Estado del servicio",
  "noReservationsForToday": "No hay reservas para hoy",
  "activeReservations": "Reservas activas",
  "unassigned": "Sin asignar",
  "noReservationsForThisDate": "No hay reservas para esta fecha",
  "next45Days": "Próximos 45 días",
  "futureReservations": "Próximas reservas",
  "noFutureReservations": "No hay próximas reservas",
  "markArrived": "Registrar llegada",
  "runningLate": "Con retraso",
  "assignTable": "Asignar mesa",
  "noShowLabel": "No presentado",
  "seatParty": "Sentar al grupo",
  "seatAssignTable": "Sentar / asignar mesa",
  "changeTable": "Cambiar mesa",
  "completeVisit": "Completar visita",
  "close": "Cerrar",
  "member": "Socio",
  "status": {
    "pending": "pendiente",
    "confirmed": "confirmada",
    "checked_in": "llegada registrada",
    "seated": "sentados",
    "completed": "completada",
    "cancelled": "cancelada",
    "no_show": "no presentado",
    "available": "disponible",
    "assigned": "asignada",
    "reserved_soon": "reservada próximamente",
    "arrived": "ha llegado",
    "blocked": "bloqueada",
    "inactive": "inactiva"
  },
  "party": "Comensales",
  "notesAllergyIndicators": "Notas / indicadores de alergias",
  "viewOnlyDiningBookingsAccess": "Acceso de solo lectura a reservas de comedor",
  "upcomingAssigned": "Próximas / asignadas",
  "noUpcomingReservationsAssignedToThisTable": "No hay próximas reservas asignadas a esta mesa.",
  "invalidClubRoute": "Ruta de club no válida",
  "useACanonicalSixDigitClubCode": "Usa un código canónico de club de seis dígitos.",
  "accessDeniedLabel": "Acceso denegado",
  "unableToLoadHostConsole": "No se pudo cargar la consola de recepción",
  "privanaCouldNotCompleteClubResolutionOrAuthorisationPleaseRetry": "Privana no pudo identificar el club o completar la autorización. Inténtalo de nuevo.",
  "signingYouOut": "Cerrando sesión…",
  "enterAClubRoute": "Introduce una ruta de club",
  "open123001ToStartDiningHostConsole": "Abre /123001 para iniciar la consola de recepción de comedor.",
  "deactivateArea": "¿Desactivar {name}?",
  "deactivateTable": "¿Desactivar la mesa {label}?",
  "cancellationDescription": "Configura la cancelación por parte de socios para {name}.",
  "noTablesForArea": "Todavía no hay mesas. Añade mesas para {name}.",
  "areaQrSummary": "Se generará un QR de zona para {name}.",
  "tableQrSummary": "Se generarán códigos QR de mesas para {name} ({count} mesas activas).",
  "tableQrSummaryOne": "Se generarán códigos QR de mesas para {name} ({count} mesa activa).",
  "qrPreview": "Vista previa del QR de {label}",
  "urlCopied": "URL copiada",
  "reservationReference": "Reserva {reference}",
  "areaTable": "{area} · Mesa {table}",
  "tableLabel": "Mesa {label}",
  "pagination": "{from}–{to} de {total}",
  "validWindow": "Introduce horas de inicio y fin válidas para el {day}.",
  "overlappingWindows": "Las franjas de servicio del {day} no pueden solaparse.",
  "selectedObjects": "{count} objetos seleccionados. Arrastra cualquier objeto seleccionado para mover el grupo o usa los atajos de teclado para duplicar, eliminar y desplazar.",
  "linkedTableSummary": "Fuente de referencia: {label} · {capacity} plazas · {status}.",
  "resizeHandle": "Cambiar tamaño: {handle}",
  "zonePointHandle": "Control del punto {number} de la zona",
  "wallPointHandle": "Control del punto {number} de la pared",
  "tableState": "Mesa {label}, {status}",
  "signOutStaff": "Cerrar sesión de {name}",
  "coverCountOne": "{count} comensal",
  "coverCountOther": "{count} comensales",
  "activeCount": "{count} activas",
  "publishedLayout": "Plano publicado · {name}",
  "serviceSummary": "En espera: {waiting} · Sentados: {seated} · Mesas disponibles: {available} · Completadas: {completed}.",
  "lateStatus": "{status} · Con retraso",
  "dateReservations": "Reservas del {date}",
  "upcomingSummary": "{time} · {count} comensales · {status}",
  "unauthorisedClub": "Tu cuenta no tiene autorización para acceder a la consola de recepción de comedor del club {clubCode}.",
  "selectDate": "Seleccionar fecha",
  "chooseServiceDate": "Elegir fecha de servicio",
  "serviceDate": "Fecha de servicio",
  "unknownStatus": "Estado desconocido",
  "unknownSource": "Origen desconocido",
  "genericError": "No se pudo completar la solicitud de comedor. Inténtalo de nuevo.",
  "requestReference": "{message} (ID de solicitud: {requestId})",
  "authRestoring": "restableciendo… sesión",
  "authAuthenticating": "autenticando",
  "authResolving": "identificando… club",
  "authAuthorising": "autorizando",
  "authLoading": "cargando",
  "topLeft": "superior izquierdo",
  "topRight": "superior derecho",
  "bottomLeft": "inferior izquierdo",
  "bottomRight": "inferior derecho",
  "source": {
    "staff": "Personal",
    "member_portal": "Portal de socios",
    "members_mobile": "App de socios",
    "guest": "Invitado",
    "walk_in": "Sin reserva"
  },
  "errors": {
    "slot_unavailable": "La mesa o la hora seleccionada ya no está disponible.",
    "party_size_out_of_range": "El número de comensales está fuera del intervalo permitido.",
    "invalid_party_size": "Introduce un número de comensales válido.",
    "invalid_guest_name": "Introduce el nombre del invitado.",
    "invalid_guest_email": "Introduce un correo electrónico válido para el invitado.",
    "invalid_guest_phone": "Introduce un teléfono válido para el invitado.",
    "invalid_member_id": "Selecciona un socio válido.",
    "member_not_found": "No se encontró al socio.",
    "area_not_found": "No se encontró la zona de comedor.",
    "table_not_found": "No se encontró la mesa.",
    "reservation_not_found": "No se encontró la reserva.",
    "reservation_terminal": "Esta reserva ya no se puede modificar.",
    "invalid_status_transition": "Este cambio de estado no está permitido.",
    "reason_required": "Introduce un motivo para esta acción.",
    "invalid_local_datetime": "Introduce una fecha y una hora válidas para la reserva.",
    "invalid_local_time": "Esta hora local no es válida en la zona horaria del club.",
    "ambiguous_local_time": "Esta hora se repite con el cambio de hora. Elige otra.",
    "invalid_duration": "Introduce una duración válida.",
    "duration_not_permitted": "Esta duración no está permitida.",
    "minimum_notice_not_met": "No se cumple la antelación mínima de reserva.",
    "outside_service_window": "La reserva está fuera de las franjas de servicio.",
    "booking_interval_mismatch": "Elige una hora que coincida con el intervalo de reservas.",
    "reservation_day_unavailable": "No hay reservas disponibles para este día de servicio.",
    "reservation_date_out_of_range": "La fecha de reserva está fuera del intervalo permitido.",
    "reservations_unavailable": "Las reservas no están disponibles para esta zona de comedor.",
    "walk_ins_disabled": "No se admiten clientes sin reserva en esta zona de comedor.",
    "guest_reservations_disabled": "No se admiten reservas de invitados en esta zona de comedor.",
    "table_block_conflicts_with_reservation": "El bloqueo de mesa coincide con una reserva.",
    "block_not_found": "No se encontró el bloqueo de mesa.",
    "invalid_table_block": "Introduce un bloqueo de mesa válido.",
    "invalid_date_filter": "Introduce un filtro de fecha válido.",
    "invalid_range": "Introduce un intervalo de números válido.",
    "rate_limited": "Demasiadas solicitudes. Inténtalo de nuevo en unos instantes.",
    "invalid_upload": "Selecciona una imagen para subir.",
    "invalid_image_type": "Sube una imagen JPEG, PNG o WebP válida.",
    "malformed_image": "La imagen está dañada, incompleta o no se pudo descodificar.",
    "image_too_large": "Las imágenes deben tener 5 MB o menos.",
    "service_windows_required": "Añade al menos una franja de servicio.",
    "overlapping_service_windows": "Las franjas de servicio no pueden solaparse.",
    "invalid_reservation_settings": "Revisa la configuración de reservas.",
    "invalid_party_size_range": "El número mínimo de comensales no puede superar el máximo.",
    "invalid_reservation_time_increment": "Los intervalos y las duraciones de reserva deben ser múltiplos de cinco minutos.",
    "invalid_booking_interval": "Introduce un intervalo de reservas de entre 5 y 240 minutos.",
    "invalid_default_duration": "Introduce una duración predeterminada de entre 15 y 720 minutos.",
    "invalid_minimum_party_size": "Introduce un mínimo de entre 1 y 100 comensales.",
    "invalid_maximum_party_size": "Introduce un máximo de entre 1 y 500 comensales.",
    "invalid_maximum_days_ahead": "Introduce una antelación máxima de entre 0 y 730 días.",
    "invalid_minimum_notice": "Introduce una antelación mínima de entre 0 y 10080 minutos.",
    "invalid_cancellation_window": "Introduce un plazo de cancelación de entre 0 y 43200 minutos.",
    "invalid_service_window_time": "Introduce horas de inicio y fin válidas para la franja de servicio.",
    "invalid_service_window_day": "Selecciona un día de servicio válido.",
    "service_window_day_disabled": "Activa el día de reserva antes de añadir una franja de servicio.",
    "invalid_service_windows": "Revisa las franjas de servicio.",
    "invalid_service_window": "Revisa la franja de servicio.",
    "invalid_reservation_days": "Selecciona días de reserva válidos.",
    "unknown_reservation_setting": "La configuración de reservas contiene una opción no compatible.",
    "invalid_area_id": "Selecciona una zona de comedor válida.",
    "invalid_table_id": "Selecciona una mesa válida.",
    "table_not_in_area": "La mesa seleccionada no pertenece a esta zona de comedor.",
    "duplicate_linked_table": "Cada mesa visual activa solo puede vincularse una vez a una mesa de comedor.",
    "linked_table_invalid": "La mesa de comedor vinculada no es válida.",
    "invalid_status": "Selecciona un estado de reserva válido.",
    "invalid_booking_source": "Selecciona un origen de reserva válido.",
    "invalid_search": "Introduce una búsqueda válida.",
    "invalid_start_at": "Introduce una hora de inicio de reserva válida.",
    "invalid_reservation_id": "Selecciona una reserva válida.",
    "floor_plan_not_found": "No se encontró el plano.",
    "invalid_floor_plan_id": "Selecciona un plano válido."
  },
  "vip": "VIP",
  "reservationCount": "{count} reservas",
  "logoutTitle": "¿Cerrar sesión de Privana?",
  "logoutDescription": "¿Seguro que quieres cerrar sesión?",
  "loggingOut": "Cerrando sesión…",
  "logOut": "Cerrar sesión",
  "print": {
    "heading": "COMEDOR PRIVANA",
    "instruction": "Escanea para ver la carta",
    "area": "QR de zona de comedor",
    "table": "QR de mesa"
  },
  "reminder": {
    "title": "Recordatorio de reserva de comedor",
    "body": "Tu reserva de comedor {reference} se acerca."
  },
  "seatCount": "{count} plazas",
  "partyStatus": "{count} comensales · {status}",
  "guestCount": "{count} comensales",
  "saved": "Cambios guardados.",
  "activeCountOne": "{count} activa",
  "reservationCountOne": "{count} reserva",
  "seatCountOne": "{count} plaza",
  "guestCountOne": "{count} comensal",
  "partyStatusOne": "{count} comensal · {status}",
  "linkedTableSummaryOne": "Fuente de referencia: {label} · {capacity} plaza · {status}.",
  "statusLabel": "Estado",
  "layerSummary": "Capa {position} de {total}",
  "elapsedMinutes": "{count} min",
  "resizeCorner": {
    "nw": "esquina superior izquierda",
    "ne": "esquina superior derecha",
    "se": "esquina inferior derecha",
    "sw": "esquina inferior izquierda"
  },
  "missingPolicyHandler": "No se puede guardar la política: no se ha configurado el controlador."
};
